export default [
  {
    path: '/activity-20251217-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-12-30T23:59:59.000+08:00', title: '圣诞节', id: 13 },
  },
  {
    path: '/activity-20251217-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-12-30T23:59:59.000+08:00', title: '圣诞节-规则', id: 13 },
  },
  {
    path: '/activity-20251217-test',
    component: () => import('./test.vue'),
    meta: { expire: '2025-12-30T23:59:59.000+08:00', title: '测试ios页面白屏' },
  },
]
